import React, { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/i18n";
import { api, track, formatApiError, getSrc } from "@/lib/api";
import PhoneInput, { Honeypot, isValidPhone } from "@/components/PhoneInput";

const inputCls = "w-full h-12 px-4 rounded-xl border border-[#E5E0D8] bg-white text-[#121316] outline-none focus:border-[#E05624] focus:ring-2 focus:ring-[#E05624]/20 transition";
const FIELDS = [["business_name", "f_shop"], ["contact_name", "f_owner"], ["phone", "f_phone"], ["area", "f_area"]];

export default function PartnerQuickForm() {
  const { t } = useLang();
  const [form, setForm] = useState({ business_name: "", contact_name: "", phone: "", area: "", website: "" });
  const [phoneErr, setPhoneErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (["business_name", "contact_name", "area"].some((k) => !form[k].trim())) { toast.error(t("required")); return; }
    if (!isValidPhone(form.phone)) { setPhoneErr(t("phone_err")); return; }
    setPhoneErr("");
    setBusy(true);
    try {
      await api.post("/partners", { ...form, city: "Bhopal", business_type: "Shop", src: getSrc() });
      track("partner_submit", { source: "home_quick" });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Failed");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div data-testid="partner-quick-success" className="chela-card rounded-3xl p-8 text-center" style={{ transform: "none" }}>
        <div className="h-14 w-14 rounded-full bg-[#E8F7EE] flex items-center justify-center mx-auto"><Check size={28} className="text-[#1B8A4B]" /></div>
        <p className="mt-4 font-display font-bold text-xl text-[#121316]">{t("pt_success")}</p>
      </div>
    );
  }
  return (
    <form data-testid="partner-quick-form" onSubmit={submit} className="chela-card rounded-3xl p-6 sm:p-7 space-y-4" style={{ transform: "none" }}>
      {FIELDS.map(([k, label]) => (
        <label key={k} className="block"><span className="block text-sm font-bold text-[#121316] mb-1.5">{t(label)}</span>
          {k === "phone"
            ? <PhoneInput testid="partner-quick-phone" value={form.phone} onChange={(v) => setForm((f) => ({ ...f, phone: v }))} error={phoneErr} />
            : <input data-testid={`partner-quick-${k}`} type="text" value={form[k]} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} required className={inputCls} />}</label>
      ))}
      <Honeypot value={form.website} onChange={(v) => setForm((f) => ({ ...f, website: v }))} />
      <button data-testid="partner-quick-submit" type="submit" disabled={busy} className="w-full h-13 py-3.5 rounded-full btn-saffron font-bold text-base disabled:opacity-60">
        {busy ? "..." : t("pt_submit")}
      </button>
    </form>
  );
}
